import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import IndustryLanding from "../views/IndustryLanding";

export default function Industry() {
  const appContext = useContext(AppContext);
  const [view, setView] = useState(null);

  useEffect(() => {
    if (
      !appContext.navSubItem &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      setView(<IndustryLanding />);
    } else {
      setView(null);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  return view;
}
